import React from 'react'
import SeminarContainer from './SeminarsContainer'

const Seminars = (props) => (
  <SeminarContainer {...props} />
)

export default Seminars



// WEBPACK FOOTER //
// ./src/components/Seminars/index.js